

// export function useHomePagaData() {

import { useEffect, useState } from "react";

import { locationPageData } from "../../Blc_Api/BlcLocationPageData/LocationPageData";

     




export function  useLocationPageData() {

    const [locationData, setLocationData] = useState();

    useEffect(()=>{
        locationPageData().then(val =>{
            setLocationData(val);
            
        })

        
    },[]);
   
    return[locationData,setLocationData];
    
}